import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RmPipe } from '@shared/pipe/rm.pipe';
import type { BookingDetailView } from '@modules/admin/finance/admin-finance.mapper';

export type { BookingDetailView };

/**
 * The admin booking-audit card (mockup `avBookingDetail`) — packages, customer escrow, the
 * per-vendor payout & advances breakdown and the booking's own ledger.
 *
 * Presentational only: it renders a `BookingDetailView` that the caller has already built with
 * `mapBookingDetail`, and owns no loader, SDK or persona of its own. Both admin surfaces that
 * open a booking show the SAME popup, so it lives here rather than inline in one of them — the
 * mockup opens `avBookingDetail` from the Finance bookings list, the vendor's own bookings list,
 * the queue trail and the fund ledger, and a second inline copy of eighty lines of money
 * rendering is exactly how two surfaces drift apart.
 *
 * `close` is an output rather than a bound callback so the host keeps ownership of its modal.
 */
@Component({
  selector: 'app-booking-audit-card',
  standalone: true,
  imports: [CommonModule, RmPipe],
  templateUrl: './booking-audit-card.component.html',
  styleUrl: './booking-audit-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingAuditCardComponent {
  /** The mapped view — `mapBookingDetail(raw, bookingId)`. */
  @Input({ required: true }) bk!: BookingDetailView;

  /** "Close" pressed. The host owns the modal, so it decides what that means. */
  @Output() readonly close = new EventEmitter<void>();
}
